import { Component, OnInit, ViewChild } from "@angular/core";
import { UsMapComponent } from "../../US-map/us-map/us-map.component";
import { UsMapService } from "../../US-map/us-map/us-map.service";

@Component({
  selector: "app-anther-map",
  templateUrl: "./anther-map.component.html",
  styleUrls: ["./anther-map.component.scss"],
})
export class AntherMapComponent implements OnInit {
  @ViewChild("usMap") usMap: UsMapComponent;
  coordinates: any = [];
  constructor(private usMapsService: UsMapService) {}

  ngOnInit(): void {
    this.coordinates = this.usMapsService.getUsMapCoordinates();
  }
}
